import { Button, type ButtonProps } from 'antd';
import { type FC, forwardRef, memo } from 'react';

interface IconButtonProps extends ButtonProps {
  buttonType?: ButtonProps['htmlType'];
  showBackground?: boolean;
  id?: string;
  dataTestId?: string;
}

const IconButton: FC<IconButtonProps> = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      children,
      onClick = () => {},
      loading = false,
      className = '',
      disabled = false,
      buttonType = 'button',
      id,
      showBackground = false,
      dataTestId = '',
      tabIndex,
    },
    ref,
  ) => {
    return (
      <Button
        id={id}
        loading={loading}
        ghost
        onClick={onClick}
        className={`icon-button ${className} ${showBackground ? 'show-background' : ''}`}
        shape="circle"
        icon={children}
        size="large"
        disabled={disabled || !!loading}
        htmlType={buttonType}
        data-testid={dataTestId}
        ref={ref}
        tabIndex={tabIndex}
      />
    );
  },
);

IconButton.displayName = 'IconButton';

export default memo(IconButton);
